export enum SecurityAction {
  ALLOW_SAVING = 'isSavingAllowed',
  ALLOW_PRINTING = 'isPrintingAllowed',
  ALLOW_EDITING = 'isEditingAllowed',
  ALLOW_COPYING = 'isCopyingAllowed',
}

export enum ChallengeType {
  EMAIL = 'Email',
  PASSCODE = 'PassCode',
  ANYONE_WITH_LINK = 'None',
  NO_ACCESS = 'NoAccess',
}

export interface Watermark {
  id: number;
  name: string;
}

export type SecurityControl = {
  isEnabled: boolean;
  isSavingAllowed: boolean | null;
  isPrintingAllowed: boolean | null;
  isEditingAllowed: boolean | null;
  isCopyingAllowed: boolean | null;
};

export type SecuritySharingState = {
  settingId?: number;
  challengeType: ChallengeType;
  sharingLink?: string;
  passCode?: string;
  securityControls: SecurityControl;
};

export interface SharingSetting {
  id?: number;
  challengeType: ChallengeType;
  passCode?: string;
  securityControls: SecurityControl;
  watermarkId?: number | null;
  expiresOn: string;
  sharingLink?: string;
}

export interface Document {
  id: number;
  name: string;
  fileExtension: string;
  isSecurable?: boolean;
  isFolder: boolean;
}

export interface SettingsFormValues {
  challengeType: ChallengeType;
  passCode?: string;
  watermarkId?: null | number;
  expiresOn?: Date;
  securityControls: SecurityControl;
}
